import { render, staticRenderFns } from "./batchCheckDialog.vue?vue&type=template&id=3987508e&scoped=true"
import script from "./batchCheckDialog.vue?vue&type=script&lang=js"
export * from "./batchCheckDialog.vue?vue&type=script&lang=js"
import style0 from "./batchCheckDialog.vue?vue&type=style&index=0&id=3987508e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3987508e",
  null
  
)

export default component.exports